import { render, staticRenderFns } from "./StoresTable.vue?vue&type=template&id=b5b001fe&scoped=true"
import script from "./StoresTable.vue?vue&type=script&lang=ts"
export * from "./StoresTable.vue?vue&type=script&lang=ts"
import style0 from "./StoresTable.vue?vue&type=style&index=0&id=b5b001fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b001fe",
  null
  
)

export default component.exports